import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect } from "react";
import { useAuth } from "../../AuthContext";
import logRocketLauncher from "../../Shared/utils/logRocketLauncher";
import Loading from "./loading";
import { LoggingContext } from "./LoggingContext/LoggingProvider";
export const Logout = () => {
    const { resetContext } = useAuth();
    const { isLogRocketEnabled } = useContext(LoggingContext);
    useEffect(() => {
        if (isLogRocketEnabled === true) {
            logRocketLauncher.logout();
        }
        resetContext();
        window.location.replace("/Refresh/Logout");
        window.localStorage.removeItem("app-cache"); // clear SWR cache on logout
    }, []);
    return _jsx(Loading, {});
};
